import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=f5c3d2a4&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=ts"
export * from "./ErrorView.vue?vue&type=script&lang=ts"
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=f5c3d2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c3d2a4",
  null
  
)

export default component.exports